<template lang="html">
  <div  id="parentx" >
    
    <vs-sidebar 
      v-if="this.$route.path !== '/login' && this.$route.path !== '/register' && this.$route.path !== '/Resetpassword' && this.$route.path !== '/login2'"
      default-index="1"
      :parent="parent"
      :hiddenBackground="doNotClose"
      class="sidebarx "
      spacer
      v-model="isSidebarActive"
      :click-not-close="doNotClose">
        <template v-for="(sidebarLink, index) in sidebarLinks.slice(sideindex[0], sideindex[1])" >
          <div v-if="username == 'betagrodemo'">
            <vs-sidebar-item
              v-if="sidebarLink.name != 'Map'"
              :icon="sidebarLink.icon"
              :to="sidebarLink.url"
              :key="`sidebarLink-${index}`"
              :index="index"
            >
              <span class="hide-in-minisidebar" id="stfont">{{ sidebarLink.name }}</span>
            </vs-sidebar-item>
          </div>
          <div v-else>
            <vs-sidebar-item
              :icon="sidebarLink.icon"
              :to="sidebarLink.url"
              :key="`sidebarLink-${index}`"
              :index="index"
            >
              <span class="hide-in-minisidebar" id="stfont">{{ sidebarLink.name }}</span>
            </vs-sidebar-item>
          </div>
        </template>
      <!---Group Manager-->
      <vs-sidebar-group  title="Device Management">
        <template v-for="(sidebarLink, index) in sidebarLinks.slice(sideindex[2], sideindex[3])">
          <vs-sidebar-item
            :icon="sidebarLink.icon"
            :to="sidebarLink.url"
            :key="`sidebarLink-${index}`"
            :index="index"
          >
            <span class="hide-in-minisidebar" id="stfont">{{ sidebarLink.name }}</span>
          </vs-sidebar-item>
        </template>
      </vs-sidebar-group>
      <!---Group Work-->
      <vs-sidebar-group  title="Manage Work" v-if="sideindex[5]">
        <vs-sidebar-item
          v-for="(sidebarLink, index) in sidebarLinks.slice(sideindex[4], sideindex[5])"
          :icon="sidebarLink.icon"
          :to="sidebarLink.url"
          :key="`sidebarLink-${index}`"
          :index="index"
        >
          <span class="hide-in-minisidebar" id="stfont">{{ sidebarLink.name }}</span>
        </vs-sidebar-item>
      </vs-sidebar-group>
      <!---Sidebar-->
      <vs-sidebar-group title="Setting">
        <vs-sidebar-item
          v-for="(sidebarLink, index) in sidebarLinks.slice(sideindex[6], sideindex[7])"
          :icon="sidebarLink.icon"
          :to="sidebarLink.url"
          :key="`sidebarLink-${index}`"
          :index="index"
        >
          <span class="hide-in-minisidebar" id="stfont">{{ sidebarLink.name }}</span>
        </vs-sidebar-item>
      </vs-sidebar-group>

      <div class="footer-sidebar center" slot="footer">
       <vs-button  class="primary mt-2 mb-3"   @click="logout" icon="logout" type="filled" id="btnbackover">
     <h6>Log Out</h6> 
        </vs-button>
        <!-- <vs-button icon="reply" color="#e74639" @click="logout" type="flat"
          >Log Out</vs-button
        > -->
      </div>
     
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  props: {
    parent: {
      type: String,
    },
    sidebarLinks: {
      type: Array,
      required: true,
    },
    index: {
      default: null,
      type: [String, Number],
    },
  },
  data: () => ({
    doNotClose: false,
    windowWidth: window.innerWidth,
    username: '',
  }),
  computed: {
    sideindex() {
      // console.log(this.$session.get('package'))
      switch(this.$session.get('package')) {
        case 0:
          return [0,5,6,7,0,0,12,14]
        case 1:
          return [0,5,6,9,9,11,11,18]
        case 2:
          return [0,2,6,7,0,0,11,14]
        case 3:
          return [0,3,6,8,0,0,12,14]
        case 4:
          return [0,5,6,9,0,0,11,15]
        default:
          return [0,3,6,7,0,0,12,14]
      }
      // if(this.$session.get('package')) {
      //   return [0,4,4,7,7,8,8,15]
      // }else{
      //   return [0,3,4,5,0,0,9,11]
      // }
    },
    //This is for mobile trigger
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", val);
      },
    },
  },
  watch: {},
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebar();
    },
    setSidebar() {
      if (this.windowWidth < 1170) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
        this.doNotClose = false;
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
      }
    },
    logout() {
      this.sideindex = []
      this.$session.clear();
      this.$router.push({
        name: "Login",
      });
    },
  },
  mounted() {
    // // console.log('SPEAK')
    // // console.log(this.$session.get('package'))
    // if(!this.$session.get('package')) {
    //   this.sideindex = [0,4,4,7,7,9,9,15]
    // }else{
    //   this.sideindex = [0,2,4,6,0,0,9,11]
    // }
    this.username = this.$session.get('username')
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebar();
  },
  beforeDestroy() {
    this.sideindex = []
    this.$session.clear();
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebar();
  },
};
</script>

<style>
#stfont{
  font-size: 14px; 
  font-family: Arial, Helvetica, sans-serif;
}
.vs-sidebar-group.vs-sidebar-group-open > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar-group > h4 {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #6c757d;
}
.vs-sidebar{
  font-size: 16.5px; 
  font-family: Arial, Helvetica, sans-serif;
   text-indent: 7px;
}
.vs-sidebar-group.vs-sidebar-group-open > h4:hover{
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  color: #47C93C;
  /* background: #48C93B; */
  /* background: #28a745;;
   color: aliceblue; */
}
.vs-sidebar-group > h4:hover  {
  font-size: 88%;
  font-weight: lighter;
  font-family: Arial, Helvetica, sans-serif;
  /* color: aliceblue; */
  color: #48C93B;
  /* background: #48C93B;
  background: #28a745;; */
}
.vuesax-app-is-ltr .vs-sidebar-group h4 i {
    right: 10px;
    top: 5.5px;
}
 .vs-sidebar-group.vs-sidebar-group-open > h4{
   
 color: aliceblue;
 
  margin: 6px;
  border-radius: 20px;
  background: #48C93B;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}
 .vs-sidebar-group.vs-sidebar-group-open > h4:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  color: aliceblue;
}
#btnbackover{
  margin:  0px 5px 0px 10px;
  border-radius: 30px;
  display: flex; 
  width: 90%;
  background-color: #4CAF50;
  align-items: center;
}
</style>